var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOnlineScamServiceBody2Mobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 169,
    viewBox: "0 0 191 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2044_2695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.8154 22.2575C58.8154 16.4851 63.4949 11.8057 69.2672 11.8057L145.064 11.8057L145.064 123.588C145.064 129.36 140.385 134.039 134.613 134.039L58.8154 134.039L58.8154 22.2575Z",
    fill: "#FFCF85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.923 11.8057L146.035 11.8057C151.808 11.8057 156.487 16.4851 156.487 22.2575L156.487 53.3318C156.487 59.1041 151.808 63.7836 146.035 63.7836L139.923 63.7836L139.923 11.8057Z",
    fill: "#FFCF85"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.665,
    y: 31.7969,
    width: 56.5474,
    height: 15.422,
    fill: "#FFF2DE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2044_2695)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.415 102.225L119.415 63.7484L125.308 63.7484C125.604 62.5974 126.419 61.6548 127.49 61.1853C127.595 61.0672 127.719 60.96 127.861 60.867L152.192 44.9258C153.969 43.7613 156.491 44.1586 157.824 45.8134L158.083 46.1341C160.416 49.0299 159.785 53.0295 156.675 55.0674L147.829 60.8627L154.696 60.8627C154.71 60.8625 154.724 60.8624 154.738 60.8624L163.9 60.8624C165.494 60.8624 166.786 62.1544 166.786 63.7481L166.786 68.5576C166.786 70.1514 165.494 71.4434 163.9 71.4434L156.12 71.4434L156.12 71.4435L161.767 71.4435C163.36 71.4435 164.652 72.7354 164.652 74.3292L164.652 78.1768C164.652 79.7705 163.36 81.0625 161.767 81.0625L159.659 81.0625C161.242 81.075 162.521 82.3621 162.521 83.9481L162.521 88.7576C162.521 90.3514 161.229 91.6434 159.636 91.6434L156.12 91.6434L156.12 91.6962C157.936 92.0045 159.319 93.5854 159.319 95.4893L159.319 98.375C159.319 100.279 157.936 101.86 156.12 102.168L156.12 102.225L126.148 102.225L125.187 102.225L119.415 102.225Z",
    fill: "#FFDCD5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2044_2695)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.10059,
    y: 107.996,
    width: 50.9809,
    height: 106.771,
    transform: "rotate(-90 1.10059 107.996)",
    fill: "#374969"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2044_2695)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.871,
    y: 105.11,
    width: 45.2095,
    height: 11.5429,
    transform: "rotate(-90 107.871 105.11)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2044_2695)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 98.7,
    cy: 102.093,
    r: 3.2,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2044_2695)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88.3006,
    cy: 102.093,
    r: 3.2,
    fill: "#D9D9D9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2044_2695",
    x: 116.215,
    y: 44.2578,
    width: 53.7711,
    height: 64.3668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2044_2695"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2044_2695",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2044_2695",
    x: -2.09941,
    y: 57.0156,
    width: 113.171,
    height: 57.3805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2044_2695"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2044_2695",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2044_2695",
    x: 104.671,
    y: 59.9004,
    width: 17.943,
    height: 51.61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2044_2695"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2044_2695",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2044_2695",
    x: 92.3,
    y: 98.8926,
    width: 12.8004,
    height: 12.8004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2044_2695"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2044_2695",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2044_2695",
    x: 81.9006,
    y: 98.8926,
    width: 12.8004,
    height: 12.8004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2044_2695"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2044_2695",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2044_2695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189.6,
    height: 168,
    fill: "white",
    transform: "translate(0.700195 0.0976562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOnlineScamServiceBody2Mobile);
export default __webpack_public_path__ + "static/media/IcOnlineScamServiceBody2Mobile.02c5cea961414369f50d9e341908e47f.svg";
export { ForwardRef as ReactComponent };